var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _componentList;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableSection = void 0;

var react_1 = __importDefault(require("react"));

var core_1 = require("@wheelroom/core");

var table_section_price_var_1 = require("./table-section-price-var");

var table_section_table_var_1 = require("./table-section-table-var");

var componentList = (_componentList = {}, _defineProperty(_componentList, 'price', table_section_price_var_1.TableSectionPriceVar), _defineProperty(_componentList, 'table', table_section_table_var_1.TableSectionTableVar), _componentList);

exports.TableSection = function (props) {
  var Variation = core_1.getVariation(props, componentList);
  return react_1.default.createElement(Variation, Object.assign({}, props));
};